<template>
  <div>
    <anamnesis
      :dataCrud.sync="localDataCrud"
      v-bind="{
        ...schema,
        modelForm,
        handleEvents,
        clickRowInfo, 
        save,
        remove,
        snackbar,
        overlay,
        overlayMessage,
        toggleOverlay,
        status,
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Anamnesis from '@/components/includes/Anamnesis';

export default {
  name: 'CAxInterviewPage',
  components: { Anamnesis },

  data: () => ({
    overlay: false,
    overlayMessage: '',
    interviewSessionId: null,
    localDataCrud: [],
  }),

  watch: {
    dataCrud: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.localDataCrud = JSON.parse(JSON.stringify(newValue));
        }
      }
    }
  },

  computed: {
    ...mapGetters('anamCAxInterview', [
      'schema',
      'dataCrud',
      'modelForm',
      'isNewRecord',
      'status',
    ]),
    ...mapGetters('anamPermissions', ['hasPermission']),
    ...mapGetters('notifications', ['snackbar']),
  },

  mounted() {
    this.loadData();
  },

  methods: {
    ...mapActions('anamCAxInterview', [
      'fetchSchema',
      'fetchRecords',
      'createRecord',
      'updateRecord',
      'removeRecord',
    ]),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.fetchRecords();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    async save() {
      try {
        const model = { dataCrud: this.localDataCrud, modelForm: this.modelForm };
        const action = this.isNewRecord ? 'createRecord' : 'updateRecord';
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        this.fetchRecords();
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    clickRowInfo(clickItem) {
      this.interviewSessionId = clickItem?.interv_session_id ?? null;
    },

    async remove() {
      if (!this.interviewSessionId) {
        return this.showSnackbar('No hay un registro seleccionado.', 'warning');
      }

      try {
        await this.removeRecord({ id: this.interviewSessionId });
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackOkRemoved || 'Eliminado correctamente.'),
          'success'
        );      } catch (error) {
        console.error('Error al eliminar:', error);
        this.showSnackbar(this.sanitizeText(this.schema.snackError), 'error');
      }

      this.fetchRecords();
    },

    handleEvents() {},

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>

<style scoped>
.placeholderColor input::placeholder {
  color: #616161 !important;
}

.textarea-top-padding .v-input__slot textarea {
  font-size: 0.75rem;
  padding-top: 8px; 
  padding-bottom: 8px; 
  text-align: justify !important;
}
</style>
